/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

/**
 * Parses dimension interval labels like:
 * "Altura menor de 30 cm" / "entre 31 cm y 60 cm" / "mayor de 181 cm"
 */
function parseDimensionInterval(label) {
  const text = String(label || '').toLowerCase();
  const nums = (text.match(/\d+(?:[.,]\d+)?/g) || []).map((n) => parseFloat(n.replace(',', '.')));
  if (!nums.length) return null;
  // ES/PT: menor/menos | NL: kleiner/minder | EN: less/under
  if (/menor|menos|less|under|hasta|kleiner|minder|onder/.test(text)) {
    return { min: 0, max: nums[0] };
  }
  // ES/PT: mayor/mais | NL: groter/meer | EN: more/over
  if (/mayor|maior|mais|more|over|above|desde|groter|meer|boven/.test(text) && nums.length === 1) {
    return { min: nums[0], max: Infinity };
  }
  // ES/PT: entre | NL: tussen | EN: between
  if (nums.length >= 2) {
    return { min: Math.min(nums[0], nums[1]), max: Math.max(nums[0], nums[1]) };
  }
  return { min: nums[0], max: nums[0] };
}

/**
 * Dual-handle slider for Altura / Ancho / Profundo list filters.
 * Maps the selected cm range onto overlapping interval checkboxes.
 */
class DimensionRangeFilter extends HTMLElement {
  connectedCallback() {
    this.sliderEl = this.querySelector('.dimension-range__slider');
    this.readout = this.querySelector('.dimension-range__readout');
    this.minInput = this.querySelector('.field__input_min');
    this.maxInput = this.querySelector('.field__input_max');
    this.checkboxes = [...this.querySelectorAll('.dimension-range__inputs input[type="checkbox"]')];
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.rangeMax = parseFloat(this.dataset.max || this.sliderEl?.dataset.max || 200);
    this.unit = this.dataset.unit || 'cm';
    this._suppress = false;

    if (!this.sliderEl || typeof noUiSlider === 'undefined') return;

    const activeIntervals = this.checkboxes
      .filter((cb) => cb.checked)
      .map((cb) => parseDimensionInterval(cb.dataset.intervalLabel))
      .filter(Boolean);

    let startMin = 0;
    let startMax = this.rangeMax;
    if (activeIntervals.length) {
      startMin = Math.min(...activeIntervals.map((i) => i.min));
      const finiteMax = activeIntervals.map((i) => i.max).filter((n) => Number.isFinite(n));
      startMax = finiteMax.length ? Math.max(...finiteMax) : this.rangeMax;
    }

    if (this.sliderEl.classList.contains('noUi-target')) {
      this.sliderEl.noUiSlider.destroy();
    }

    noUiSlider.create(this.sliderEl, {
      start: [startMin, startMax],
      connect: true,
      step: 1,
      direction: document.dir,
      range: { min: 0, max: this.rangeMax }
    });

    this.sliderEl.noUiSlider.on('update', (values) => {
      const min = Math.round(values[0]);
      const max = Math.round(values[1]);
      if (this.minInput) this.minInput.value = min;
      if (this.maxInput) this.maxInput.value = max;
      if (this.readout) this.readout.textContent = `${min} – ${max} ${this.unit}`;
    });

    this.sliderEl.noUiSlider.on('change', (values) => {
      this.applyRange(Math.round(values[0]), Math.round(values[1]), true);
    });

    const onManualInput = () => {
      if (this._suppress) return;
      let min = parseFloat(this.minInput.value);
      let max = parseFloat(this.maxInput.value);
      if (Number.isNaN(min)) min = 0;
      if (Number.isNaN(max)) max = this.rangeMax;
      if (min > max) [min, max] = [max, min];
      this.sliderEl.noUiSlider.set([min, max]);
      this.applyRange(min, max, true);
    };
    this.minInput?.addEventListener('change', onManualInput);
    this.maxInput?.addEventListener('change', onManualInput);

    // Solo sincronizar checks si ya habia intervalos activos
    if (activeIntervals.length) {
      this.applyRange(startMin, startMax, false);
    }
  }

  applyRange(min, max, dispatch) {
    const fullRange = min <= 0 && max >= this.rangeMax;
    let changed = false;
    this.checkboxes.forEach((cb) => {
      if (cb.disabled) return;
      const interval = parseDimensionInterval(cb.dataset.intervalLabel);
      const overlaps = !fullRange && interval && interval.max >= min && interval.min <= max;
      if (cb.checked !== !!overlaps) {
        cb.checked = !!overlaps;
        changed = true;
      }
    });
    if (dispatch && changed && this.form) {
      this.form.querySelector('form')?.dispatchEvent(new CustomEvent('input'));
    }
  }
}
customElements.define('dimension-range-filter', DimensionRangeFilter);

/**
 *  @class
 *  @function FacetBubble
 *  Amazon-style quick-access filter: a bubble button that opens a dropdown
 *  panel with all of that filter's options. The checkboxes inside live in
 *  the same <form> as the rest of the bar, so the existing FacetFiltersForm
 *  'input' listener picks up changes without any extra wiring here.
 */
class FacetBubble extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.facet-bubble__toggle');
    this.panel = this.querySelector('.facet-bubble__panel');
    this.filterParam = this.dataset.filterParam;
    this.form = this.closest('facet-filters-form')?.querySelector('form') || null;

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onOtherOpen = this.onOtherOpen.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onPanelInput = this.onPanelInput.bind(this);

    if (this.button) this.button.addEventListener('click', this.onToggleClick);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('facet-bubble:open', this.onOtherOpen);
    window.addEventListener('resize', this.onResize);
    document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
    this.onHeaderMenuIntent = this.onHeaderMenuIntent.bind(this);
    document.addEventListener('mouseover', this.onHeaderMenuIntent, { passive: true });

    // Re-open across the AJAX HTML swap that follows every filter change,
    // so picking several options doesn't require reopening the panel each time.
    if (this.filterParam && this.filterParam === FacetBubble.openFilterParam) {
      this.setOpen(true, { announce: false });
    }
  }

  disconnectedCallback() {
    this.unmountPanel();
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('facet-bubble:open', this.onOtherOpen);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('scroll', this.onScroll, { capture: true });
    document.removeEventListener('mouseover', this.onHeaderMenuIntent);
  }

  get isOpen() {
    return this.classList.contains('is-open');
  }

  onToggleClick(event) {
    event.preventDefault();
    this.setOpen(!this.isOpen);
  }

  setOpen(open, { announce = true } = {}) {
    if (open) {
      if (announce) {
        document.dispatchEvent(new CustomEvent('facet-bubble:open', { detail: { source: this } }));
      }
      FacetBubble.openFilterParam = this.filterParam || null;
      this.classList.add('is-open');
      if (this.button) this.button.setAttribute('aria-expanded', 'true');
      if (this.panel) this.panel.hidden = false;
      this.mountPanel();
      this.positionPanel();
    } else {
      if (FacetBubble.openFilterParam === this.filterParam) {
        FacetBubble.openFilterParam = null;
      }
      this.classList.remove('is-open');
      if (this.button) this.button.setAttribute('aria-expanded', 'false');
      if (this.panel) this.panel.hidden = true;
      this.unmountPanel();
    }
  }

  // iOS Safari traps position:fixed inside overflow-x + -webkit-overflow-scrolling
  // containers, so the dropdown paints under product images. Move the panel to
  // <body> while open; keep inputs linked via the HTML form="" attribute.
  mountPanel() {
    if (!this.panel || this._panelPortaled) return;

    if (this.form?.id) {
      this.panel.querySelectorAll('input[name]').forEach((input) => {
        input.setAttribute('form', this.form.id);
      });
    }

    this._panelPlaceholder = document.createComment('facet-bubble-panel');
    if (this.panel.parentNode) {
      this.panel.parentNode.insertBefore(this._panelPlaceholder, this.panel);
    }
    this.panel.addEventListener('input', this.onPanelInput);
    document.body.appendChild(this.panel);
    this._panelPortaled = true;
  }

  unmountPanel() {
    if (!this.panel || !this._panelPortaled) return;
    this.panel.removeEventListener('input', this.onPanelInput);
    if (this._panelPlaceholder?.parentNode) {
      this._panelPlaceholder.parentNode.insertBefore(this.panel, this._panelPlaceholder);
      this._panelPlaceholder.remove();
    }
    this._panelPlaceholder = null;
    this._panelPortaled = false;
  }

  onPanelInput() {
    // Inputs live outside the <form> while portaled; re-dispatch so FacetFiltersForm
    // still builds FormData from the form (includes form=""-associated fields).
    if (this.form) {
      this.form.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  // Centers the panel under the bubble, but never lets it spill past the
  // viewport edge. Positioned in fixed (viewport) coordinates so it isn't
  // clipped by the horizontal scroll on .facet-bubbles (see facets.css).
  positionPanel() {
    if (!this.panel) return;
    const margin = 16;
    const buttonRect = this.getBoundingClientRect();
    const panelWidth = this.panel.offsetWidth || Math.min(320, window.innerWidth - 32);
    const idealLeft = buttonRect.left + buttonRect.width / 2 - panelWidth / 2;
    const maxLeft = window.innerWidth - panelWidth - margin;
    const clampedLeft = Math.max(margin, Math.min(idealLeft, maxLeft));
    this.panel.style.left = `${clampedLeft}px`;
    this.panel.style.top = `${buttonRect.bottom + 8}px`;
  }

  onResize() {
    if (this.isOpen) this.positionPanel();
  }

  onScroll(event) {
    if (!this.isOpen) return;
    // A scroll inside the panel itself (long options list) shouldn't close it.
    if (this.panel && event.target !== document && event.target !== window && this.panel.contains(event.target)) return;
    // iOS Safari fires scroll events when the panel opens (address bar /
    // visual viewport changes), which used to close it instantly. Keep it
    // open and follow the bubble; close only if the bubble leaves the screen.
    const rect = this.getBoundingClientRect();
    if (rect.right < 0 || rect.left > window.innerWidth || rect.bottom < 0 || rect.top > window.innerHeight) {
      this.setOpen(false);
      return;
    }
    this.positionPanel();
  }

  onOtherOpen(event) {
    if (event.detail.source !== this) this.setOpen(false, { announce: false });
  }

  onHeaderMenuIntent(event) {
    if (!this.isOpen) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('.header-section .menu-item-has-megamenu, .header-section .mega-menu-container, .header-section .sub-menu')) {
      this.setOpen(false, { announce: false });
    }
  }

  onDocumentClick(event) {
    if (!this.isOpen) return;
    const inBubble = this.contains(event.target);
    const inPanel = this.panel && this.panel.contains(event.target);
    if (!inBubble && !inPanel) this.setOpen(false);
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.setOpen(false);
      if (this.button) this.button.focus();
    }
  }
}
FacetBubble.openFilterParam = null;
customElements.define('facet-bubble', FacetBubble);

window.addEventListener('load', () => {
  new FacetsToggle();
});